{
  "global": {
    "action": "Action",
    "actions": "Actions",
    "actiontemplate": "action template",
    "actiontemplates": "action templates",
    "add": "Add",
    "added": "added",
    "area": "Area",
    "areas": "Areas",
    "category": "Category",
    "categories": "Categories",
    "choose": "choose",
    "choose-multi": "Choose multiple",
    "choose-date": "choose date",
    "check": "check",
    "combined": "combined",
    "comments": "Comments",
    "content": "Content",
    "copy": "Copy",
    "could_not_add": "Could not add",
    "create": "Create",
    "crm": "CRM",
    "days": "Days",
    "delete": "Delete",
    "details": "Details",
    "domain": "Domain",
    "do-not-set": " do not set",
    "email": "email",
    "encryption": "encryption",
    "file": "File",
    "filename": "Filename",
    "format": "format",
    "found": "found",
    "handling": "handling",
    "history": "history",
    "identifier": "identifier",
    "lastmodified": "last modified",
    "list": "list",
    "month": "month",
    "men": "men",
    "name": "Name",
    "status": "Status",
    "edit": "Edit",
    "extra": "Extra",
    "filter": "Filter",
    "active": "Active",
    "info": "Information",
    "inactive": "Inactive",
    "ignore": "Ignore",
    "ignored": "Ignored",
    "male": "Male",
    "female": "Female",
    "type": "Type",
    "all": "all",
    "more": "More",
    "mandatoryfields": "Mandatory fields",
    "or": "or",
    "orderby": "Order by",
    "other": "other",
    "from": "From",
    "prefill": "Prefill",
    "to": "To",
    "yes": "Yes",
    "limit": "limit",
    "no": "No",
    "null": "NULL",
    "mode": "Mode",
    "in": "In",
    "not-in": "Not in",
    "date": "date",
    "search": "search",
    "set": "set",
    "source": "Source",
    "sources": "Sources",
    "setting": "Setting",
    "use": "use",
    "show": "show",
    "sum": "sum",
    "upload": "Upload",
    "user": "User",
    "users": "Users",
    "title": "title",
    "total": "Total",
    "women": "women"
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "username": "Username",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password",
    "permissions": "Permissions",
    "edit": "edit",
    "delete": "delete",
    "extra": "extra",
    "read": "read",
    "add": "add",
    "set-permissions": "Set permissons"
  },

  "users": {
    "list": "show users",
    "loginname": "Login Name",
    "add": "Add user",
    "fullname": "Full name",
    "password": "Password",
    "useradd": "Add user"
  },
  "actions": {
    "age": "Age",
    "add": "Add action",
    "add_template": "Add template",
    "address": "Address",
    "ages-gender-ratios": "ages gender ratios",
    "autonom-regions": "Autonom regions",
    "amount": "Amount",
    "blacklist": "Blacklist",
    "blacklists": "Blacklists",
    "block": "Block",
    "blocks": "Blocks",
    "block-days": "block for days",
    "blocked-users": "blocked users",
    "brutos_no_optouts": "no optouts for brutos",
    "dependants": "Dependants",
    "checking": "Just checking",
    "children": "Children",
    "clone": "Clone",
    "commaorspaceseparated": "comma or space separated",
    "counting": "Counting",
    "created": "Action Created",
    "credit_amount": "Credit amount",
    "credit_status": "Credit status",
    "credit_period": "Credit period",
    "cycleaction": "Cyclic action",
    "data-created": "Data created",
    "days-from-delivery": "days from scheduledate or delivery",
    "deliver": "Deliver",
    "delivery": "Delivery",
    "delivered": "delivered",
    "delivery-data": "Delivery-data",
    "download": "download",
    "duplicates": "duplicates",
    "grossdelivered": "Gross delivered",
    "create-data": "Create data",
    "recreate-raw-data": "Recreate raw data",
    "create-raw-data": "Create raw data",
    "deliveryformat": "Delivery format",
    "formatteddelivery": "Formatted Delivery",
    "in-past-days": "in the past * days",
    "formatcsv": "format csv",
    "exclude-global-unsubs": "exclude global unsubscribes",
    "estimated": "estimated",
    "getamount": "get amount",
    "impact": "Impact",
    "block-until": "Block until",
    "capitals": "Capital cities",
    "check-robinson": "Check Robinson",
    "consent-3rds": "Consent 3rds",
    "delete": "Delete action",
    "delivered-to": "Delivered to",
    "exclude-actions": "Exclude actions",
    "exclude_only": "exclude only",
    "doi": "DOI",
    "education": "Education",
    "email": "email",
    "executiondate": "Execution date",
    "exclude-users-delivered": "Exclude delivered users",
    "fileheader": "file header",
    "select-only-users-delivered": "Select only delivered users",
    "gender": "Gender",
    "home_status": "Home status",
    "income_source": "Income source",
    "keep_gross": "keep gross status",
    "last_phonecheck": "last phone check",
    "marital_status": "Martital status",
    "monthly_income": "Monthly income",
    "new-amount": "New amount",
    "howmanykids": "How many",
    "scheduledate": "Schedule date",
    "list": "List actions",
    "title": "Action Title",
    "include-blocks": "Include blocks",
    "job_area": "Job area",
    "job_start": "Job start",
    "exclude-global-blocks": "Exclude global blocks",
    "exclude-all-blocks": "Exclude all blocks",
    "filter-content": "Filter content",
    "geotargeting": "Geo targeting",
    "firstuse": "First use",
    "fixed-phone": "Fixed phone",
    "is-robinson": "Is Robinson",
    "keep_status_gross": "keep status gross",
    "mobile-phone": "Mobile phone",
    "mobile-operators": "Mobile operator",
    "mobile-or-fix": "Mobile or fix phone",
    "nationalities": "Nationalities",
    "phonefilter": "Phone filter",
    "search-criteria": "Search criteria",
    "masculin": "only men",
    "participations": "Participations",
    "percentage": "Percentage",
    "postprocessfilter": "Postprocess filter",
    "postprocessfilters": "Postprocess filters",
    "feminin": "only women",
    "birthday": "Birthday",
    "haschildren": "Has children",
    "querydetails": "Query details",
    "random": "Random",
    "ratio": "ratio",
    "reduce": "Reduce",
    "regdate": "Regdate",
    "regdate_asc": "Regdate asc (oldest entries)",
    "regdate_desc": "Regdate desc (newest entries)",
    "regions": "Provinces",
    "robinsonspares": "Robinson spares",
    "mailing": "Mailing",
    "postprocess": "post process",
    "phone": "Phone",
    "reasons": "Reasons",
    "restofregion": "Rest of region",
    "send_data_as": "You are about to send the data as",
    "set_equally": "set equally",
    "sms": "SMS",
    "subids": "Subids",
    "startdate": "Start date",
    "totalamount": "Total amount",
    "uniqueid": "unique id",
    "uniqueids": "unique ids",
    "upload_nets": "upload nets",
    "use-csv": "Use csv",
    "use-all": "Use all",
    "use-postprocess": "Use postprocess",
    "vehicle_type": "Vehicle type",
    "zip": "postal code",
    "will_be_marked_as_delivered": "Action will be marked as delivered!!!",
    "withaddress": "with address",
    "withfulladdress": "with full address (incl. floor)",
    "withfulladdressnofloor": "with full address (excl. floor)",
    "withoutcapitals": "without capitals"
  },
  "crm": {
    "adjustment": "adjustment",
    "anonymize": "anonymize",
    "beneficiary": "Beneficiary",
    "beneficiaries": "Beneficiaries",
    "city": "City",
    "client": "Client",
    "clients": "Clients",
    "client_added": "Client added",
    "country": "country",
    "could_not_add_client": "could not add client",
    "could_not_create_action": "could not create action",
    "company": "Company Name",
    "computed": "Computed",
    "controlling": "Controlling",
    "cpa": "CPA",
    "cpl": "CPL",
    "default_values": "Default values",
    "delivery_formats": "Delivery formats",
    "delivery_settings": "Delivery settings",
    "divider": "Divider",
    "fields": "Fields",
    "gross": "Gross",
    "invoice": "Invoice",
    "invoice-amount": "Invoice Sum",
    "invoice-nr": "Invoice Number",
    "invoice-not-sent": "Invoice not sent",
    "invoice-open": "Invoice open",
    "invoice-paid": "Invoice paid",
    "invoice-provision": "Outstanding",
    "io": "insertion order",
    "finance": "Finance",
    "partner": "Partner",
    "partners": "Partners",
    "pay_type": "Payment type",
    "pending": "Pending",
    "persistent": "Keep old data",
    "petitions": "Petitions",
    "provider": "Provider",
    "province": "Province",
    "net": "Net",
    "shortname": "Shortname",
    "contact": "Contact name",
    "broker": "Broker",
    "role": "Role",
    "roles": "Roles",
    "street": "Street",
    "treater": "Treater",
    "vatid": "Vat ID",
    "inform_optouts": "Inform about optouts",
    "inform_optouts_settings": "Inform optouts setting",
    "inform_optouts_partnersettings": "Inform optouts (partners)",
    "recipient": "Recipient",
    "recipients": "Recipients",
    "samples_regarding": "Samples regarding",
    "subject": "Subject",
    "universal": "Universal"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "Navigation Layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "dashboard": "Dashboard",
    "inventory": "Inventory",
    "list": "Search/List",
    "login": "Login",
    "maps": "Maps",
    "pages": "Pages",
    "petitiontemplates": "Petition templates",
    "modals": "Modals",
    "myaccount": "My account",
    "notifications": "Notifications",
    "predefined-selections": "Predefined selections",
    "signUp": "Sign up",
    "statistics": "Statistics",
    "fileUpload": "File Upload",
    "login-signup": "Login/Signup",
    "404-pages": "404 Pages",
    "faq": "Faq",
    "system": "System",
    "uploadunsubscribes": "upload unsubscribes",
    "users": "Admin Users"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  }
}
